<template>

  <div>
    <!-- 使用transition组件解决路由跳转页面卡顿感 -->

<!--    <transition name="fade-transform" mode="out-in">-->

<!--      <router-view/>-->
<!--      <router-view class="animate__animated animate__flip  animate__slow" />-->

<!--    <router-view class="animate__animated animate__rotateIn " />-->

      <router-view class="animate__animated animate__zoomIn " />

<!--    <router-view class="animate__animated animate__backInDown " />-->

<!--    <router-view class="animate__animated animate__bounceInDown " />-->

<!--        <router-view class="animate__animated animate__bounceInLeft " />-->

<!--      <router-view class="animate__animated animate__fadeIn " />-->
<!--    <router-view class="animate__animated animate__fadeInDown " />-->


<!--    <router-view class="animate__animated animate__fadeInDownBig " />-->



    <!--        </transition>-->
  </div>

</template>

<script>
import 'animate.css';


  export default {
    name: 'App',
    data () {
      return {
        currPath: '/' // 路径 用于判断哪些页面不显示公共组件
      }
    },
    mounted () {
      this.currPath = this.$route.path
      // const wx = window.wx;
      // let herf = window.sessionStorage.getItem('firstEntryUrl').split('#')[0]
      // let code = herf.substring(herf.indexOf("code=") + 5, herf.indexOf("&state"))
      // this.axios({
      //   method: "post",
      //   url: "https://accloveapi.siaa.org.cn/get_wx_config",
      //   data: {
      //     url: window.sessionStorage.getItem('firstEntryUrl').split('#')[0]
      //   }
      // }).then((res) => {
      //   // 配置微信注入信息
      //   wx.config({ //  通过后端
      //     debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印
      //     appId: 'wx6c0a281d3ef4bb03', // 必填，公众号的唯一标识
      //     timestamp: res.data.t, // 必填，生成签名的时间戳
      //     nonceStr: res.data.nonceStr, // 必填，生成签名的随机串
      //     signature: res.data.sign, // 必填，签名
      //     jsApiList: ['updateAppMessageShareData', 'updateTimelineShareData'] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
      //   })
      // })
      //
      //
      // // 拉取用户信息
      // this.axios({
      //   method: 'get',
      //   url: 'https://accloveapi.siaa.org.cn/get_userinfo?code=' + code
      // }).then((res) => {
      //   this.nickname = res.data['nickname']
      //   this.headimgurl = res.data['headimgurl']
      //   Common.nickname = this.nickname
      //   Common.headimgurl = this.headimgurl
      //   // localStorage.setItem("nickname", res.data['nickname'])
      //   // localStorage.setItem("headimgurl", res.data['headimgurl'])
      // })



      // const t = Date.parse(new Date()) / 1000
      // alert("时间是否存在：" + localStorage.getItem("time"))
      // if (localStorage.getItem("time") != null) {
      //   alert("时间相差了：" + t - localStorage.getItem("time"))
      //   if (t - localStorage.getItem("time") >= 86400) {
      //     localStorage.removeItem("nickname")
      //     localStorage.removeItem("headimgurl")
      //     localStorage.setItem("time", t)
      //     if (localStorage.getItem("nickname") != null || localStorage.getItem("headimgurl") != null) {
      //       //
      //       // } else {
      //       // 拉取用户信息
      //       this.axios({
      //         method: 'get',
      //         url: 'https://accloveapi.siaa.org.cn/get_userinfo?code=' + code
      //       }).then((res) => {
      //         this.nickname = res.data['nickname']
      //         this.headimgurl = res.data['headimgurl']
      //         localStorage.setItem("nickname", res.data['nickname'])
      //         localStorage.setItem("headimgurl", res.data['headimgurl'])
      //       })
      //
      //       // }
      //     } else {
      //       // if (localStorage.getItem("nickname") != null || localStorage.getItem("headimgurl") != null) {
      //
      //       // } else {
      //       // 拉取用户信息
      //       this.axios({
      //         method: 'get',
      //         url: 'https://accloveapi.siaa.org.cn/get_userinfo?code=' + code
      //       }).then((res) => {
      //         this.nickname = res.data['nickname']
      //         this.headimgurl = res.data['headimgurl']
      //         localStorage.setItem("nickname", res.data['nickname'])
      //         localStorage.setItem("headimgurl", res.data['headimgurl'])
      //       })
      //
      //     }
      //     // }
      //   } else {
      //     if (localStorage.getItem("nickname") != null || localStorage.getItem("headimgurl") != null) {
      //     } else {
      //       // 拉取用户信息
      //       this.axios({
      //         method: 'get',
      //         url: 'https://accloveapi.siaa.org.cn/get_userinfo?code=' + code
      //       }).then((res) => {
      //         this.nickname = res.data['nickname']
      //         this.headimgurl = res.data['headimgurl']
      //         const t = Date.parse(new Date()) / 1000
      //         localStorage.setItem("time", t)
      //         localStorage.setItem("nickname", res.data['nickname'])
      //         localStorage.setItem("headimgurl", res.data['headimgurl'])
      //       })
      //
      //     }
      //   }
      //
      //
      // }
      //



    }
  }
</script>


<style>


/*
enter-active 定义进入过渡的结束状态
leave-active 定义离开过渡的结束状态
 */
.fade-transform-leave-active,
.fade-transform-enter-active {
  transition: all 0.6s;
}

/*
enter定义进入过渡的开始状态
 */
.fade-transform-enter {
  opacity: 0;
  transform: translateX(400px);
}
/*
leave-to离场动画结束后的状态
 */
.fade-transform-leave-to {
  opacity: 0;
  transform: translateX(-400px);
}



  #app {

  }

  a {
    color: #409EFF;
    text-decoration: none;
  }

  ul {
    margin: 0;
    padding: 0
  }


  * {
    margin: 0;
    padding: 0;
  }

  /*html{*/
  /*  top:-2px;*/
  /*  position: relative;*/
  /*  background: url("../static/image/bg.jpg") no-repeat;*/
  /*  -webkit-background-size: 100%;*/
  /*  background-size: 100%;*/
  /*}*/
  /*.apps{*/
  /*  height:1000px;*/
  /*  width:100%;*/
  /*  margin:-10px;*/
  /*  padding:-10px;*/
  /*  background: rgba(0,0,0,.6);*/
  /*}*/

  /*html{*/
  /*  !*网站全局变灰效果*!*/
  /*  -webkit-filter: grayscale(.90);*/
  /*}*/

  /*!*禁止选择文字*!*/
  /**{*/
  /*  -webkit-touch-callout:none;  !*系统默认菜单被禁用*!*/
  /*  -webkit-user-select:none; !*webkit浏览器*!*/
  /*  -khtml-user-select:none; !*早期浏览器*!*/
  /*  -moz-user-select:none;!*火狐*!*/
  /*  -ms-user-select:none; !*IE10*!*/
  /*  user-select:none;*/
  /*}*/
  /*input{*/
  /*  -webkit-user-select:auto; !*webkit浏览器*!*/
  /*}*/
  /*textarea{*/
  /*  -webkit-user-select:auto; !*webkit浏览器*!*/
  /*}*/


  body{
    -webkit-text-size-adjust: 100% !important;
    text-size-adjust: 100% !important;
    -moz-text-size-adjust: 100% !important;
  }


  html,body,#app{
    height: 100%;

  }

</style>



// WEBPACK FOOTER //
// src/App.vue